import { PiniaColadaDevtools } from "@pinia/colada-devtools";
import { useStorage } from "@vueuse/core";
import { computed, defineComponent } from "vue";
import { RouterView } from "vue-router";
import BrowserNotSupported from "./BrowserNotSupported";
import { usePreferenceShortcuts } from "./composables/use-preference-shortcuts";
import Config from "./Conf";
import environment from "./environment";
import MaintenancePage from "./pages/MaintenancePage";
import { useUserProfile } from "./stores/user-profile.store";
import { actualVersion, browser, isSupported, minimumVersion } from "./utils/browser-support";

declare const __PINIA_COLADA_DEVTOOLS__: boolean;

export default defineComponent({
  name: "App",
  setup() {
    const dismiss = useStorage("browser-support-dismiss", false);

    const isMaintenanceMode = environment.VITE_MAINTENANCE_MODE === "true";

    // Theme/language shortcuts on public screens; the authenticated shell owns
    // them once a user is loaded, so exactly one owner is active at a time.
    const isAuthenticated = computed(() => !!useUserProfile().user);
    usePreferenceShortcuts({ enabled: () => !isAuthenticated.value });

    return () => (
      <Config>
        {isMaintenanceMode ? (
          <MaintenancePage />
        ) : isSupported || dismiss.value ? (
          <RouterView />
        ) : (
          <BrowserNotSupported
            v-model:dismiss={dismiss.value}
            browser={browser}
            actualVersion={actualVersion}
            minimumVersion={minimumVersion}
          />
        )}
        {__PINIA_COLADA_DEVTOOLS__ && <PiniaColadaDevtools />}
      </Config>
    );
  },
});
